import { connect } from 'react-redux';
import { List } from 'semantic-ui-react';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

export const EditOrganizationUsers = ({ organization }) => {
  const getPage = () => (
    <List selection verticalAlign="middle" divided>
      {organization.users.map(user => (
        <List.Item key={user.id}>
          <Link to={'/admin/user/' + user.id}>
            <List.Content>
              <List.Icon name="user circle outline" />
              {user.name}
            </List.Content>
          </Link>
        </List.Item>
      ))}
    </List>
  );

  return getPage();
};

const mapStateToProps = state => ({
  users: selectors.getUsers(state),
  organization: selectors.getCurrentGroup(state),
});

const mapDispatchToProps = dispatch => ({
  setGroup: bindActionCreators(actions.admin.setGroup, dispatch),
  updateGroup: bindActionCreators(actions.admin.updateUserGroup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditOrganizationUsers);
